import { useState } from "react";

export default function useLoader(defaultIsLoading: boolean = false) {
  const [isLoading, setIsLoading] = useState(defaultIsLoading);

  function start() {
    setIsLoading(true);
  }

  function stop() {
    setIsLoading(false);
  }

  return { isLoading, start, stop };
}
